<template>
  <el-popover v-if="resources.length" placement="bottom-start" :width="400" :open-delay="200" trigger="hover" :visible-arrow="false">
    <div class="product-online-doc-content">
      <el-table :data="resources" style="width: 100%;">
        <el-table-column label="商品资料" prop="title" min-width="120" show-overflow-tooltip></el-table-column>
      </el-table>
    </div>
    <div slot="reference" class="ml-sm text-primary" style="line-height: 1;">
      <i role="button" class="el-icon-document" style="font-size: 18px;"></i>
    </div>
  </el-popover>
</template>

<script>
export default {
  name: 'ProductOnlineDoc',

  props: {
    resources: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {

    }
  },
  mounted() {

  },
  computed: {

  },
  methods: {

  },
}
</script>

<style scoped lang="scss"></style>
